<template lang="pug">
app-page( title="Лог заявок на внесение денежных средств" )
  app-toolbar( title="Лог заявок на внесение денежных средств" )
  v-data-table( :headers="headers" 
                :items="currentItems"
                :items-per-page.sync="itemsPerPage"
                :server-items-length="pagination.totalItems"
                :footer-props="{ 'items-per-page-options': [5, 10, 15, 20, 100] }"
                @update:page="handleUpdatePage")
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'QrCodeLogsPage',

  data() {
    return {
      itemsPerPage: 5,
      currentPage: 0,
      headers: [
        { text: 'Дата создания', value: 'createdDate' },
        { text: 'Плательщик', value: 'payer' },
        { text: 'Вид плательщика', value: 'personaType' },  
        { text: 'Тип дела', value: 'caseType' },
        { text: 'Номер дела', value: 'courtCase' },
        { text: 'Сумма депозита', value: 'summa' },
      ]
    }
  },

  computed: {
    ...mapState('expert', ['logList', 'pagination']),

    currentItems() {
      console.log(this.itemsPerPage)
      console.log(this.currentPage * this.itemsPerPage, (this.currentPage * this.itemsPerPage) + this.itemsPerPage)
      return this.logList.slice(this.currentPage * this.itemsPerPage, (this.currentPage * this.itemsPerPage) + this.itemsPerPage) ?? []
    }
  },

  methods: {
    ...mapActions('expert', ['getQrCodeLog', 'getQrCodeLogByPage']),

    handleUpdatePage($event) {
      this.currentPage = $event - 1
      if ((this.currentPage * this.itemsPerPage) + this.itemsPerPage >= this.pagination.pagesLoaded * this.pagination.size) {
        this.getQrCodeLogByPage(this.pagination.pagesLoaded + 1)
      }
    }
  },

  mounted() {
    this.getQrCodeLogByPage(1)
  }
}
</script>